export const movies = [
  {
    id: 1,
    title: "Purna Bahadur Ko Sarangi",
    year: 2024,
    genre: ["Drama", "Music", "Family"],
    runtime: "2h 20m",
    director: "Nabin Chauhan",
    cast: ["Bijay Baral", "Bipin Karki", "Miruna Magar"],
    synopsis: "Purna Bahadur is a sarangi player from a remote village who earns a living through his music after being abandoned by his wife. Left to raise his son alone, he becomes determined to give him a better future through education.",
    score: 9.1,
    totalRatings: 1240,
    emoji: "🏔",
    color: "#2a1a10",
    whereToWatch: [
      { name: "Cinemaghar", type: "rent · Rs 200", free: false },
      { name: "MSM Video", type: "subscription", free: false },
      { name: "YouTube", type: "free · with ads", free: true },
    ],
    ratings: { masterpiece: 24, dhamaka: 68, thaikaicha: 6, timepass: 2, naramro: 0, bakwaas: 0 },
    boxOffice: "Rs 51.4 cr",
    trending: true,
  },
  {
    id: 2,
    title: "Unko Sweater",
    year: 2025,
    genre: ["Romance", "Drama"],
    runtime: "1h 58m",
    director: "Nabin Chauhan",
    cast: ["Bipin Karki", "Miruna Magar", "Alex Paras"],
    synopsis: "Set on the eastern hills of Nepal, a quiet love story unfolds between Dharanidhar and Phool — told through a hand-knitted sweater that becomes the thread of memory and longing across their lives.",
    score: 8.5,
    totalRatings: 870,
    emoji: "🧶",
    color: "#101a10",
    whereToWatch: [
      { name: "MSM Video", type: "subscription", free: false },
      { name: "YouTube", type: "free · with ads", free: true },
    ],
    ratings: { masterpiece: 18, dhamaka: 55, thaikaicha: 20, timepass: 5, naramro: 2, bakwaas: 0 },
    boxOffice: "Rs 12.8 cr",
    trending: true,
  },
  {
    id: 3,
    title: "Pashupati Prasad",
    year: 2016,
    genre: ["Comedy", "Drama"],
    runtime: "2h 08m",
    director: "Dipendra K. Khanal",
    cast: ["Khagendra Lamichhane", "Rabindra Singh Baniya", "Bipin Karki"],
    synopsis: "When Pashupati Prasad travels to Kathmandu to repay his father's debts, he discovers the scared city and the hilarious, heartbreaking world of survival.",
    score: 8.9,
    totalRatings: 2100,
    emoji: "🎭",
    color: "#1a1025",
    whereToWatch: [
      { name: "YouTube", type: "free · with ads", free: true },
      { name: "Netflix", type: "subscription", free: false },
    ],
    ratings: { masterpiece: 30, dhamaka: 52, thaikaicha: 14, timepass: 3, naramro: 1, bakwaas: 0 },
    boxOffice: "Rs 8.2 cr",
    trending: false,
  },
  {
    id: 4,
    title: "Kabaddi",
    year: 2014,
    genre: ["Drama", "Romance"],
    runtime: "2h 11m",
    director: "Ram Babu Gurung",
    cast: ["Dayahang Rai", "Saugat Malla", "Rishma Gurung"],
    synopsis: "Kaji dreams of marrying Maiya but things go wrong when Bamkaji returns to the village who also wants to marry Maiya. A story of love, rivalry, and village life.",
    score: 8.7,
    totalRatings: 1800,
    emoji: "🌄",
    color: "#1a1500",
    whereToWatch: [
      { name: "YouTube", type: "free · with ads", free: true },
    ],
    ratings: { masterpiece: 22, dhamaka: 58, thaikaicha: 16, timepass: 3, naramro: 1, bakwaas: 0 },
    boxOffice: "Rs 6.5 cr",
    trending: false,
  },
  {
    id: 5,
    title: "Chhakka Panja 5",
    year: 2024,
    genre: ["Comedy"],
    runtime: "2h 15m",
    director: "Deepa Shree Niraula",
    cast: ["Deepak Raj Giri", "Kedar Ghimire", "Priyanka Karki"],
    synopsis: "The fifth instalment of Nepal's most beloved comedy franchise returns with the gang in new hilarious situations.",
    score: 7.8,
    totalRatings: 640,
    emoji: "😂",
    color: "#10101a",
    whereToWatch: [
      { name: "MSM Video", type: "subscription", free: false },
    ],
    ratings: { masterpiece: 8, dhamaka: 42, thaikaicha: 32, timepass: 12, naramro: 4, bakwaas: 2 },
    boxOffice: "Rs 9.1 cr",
    trending: true,
  },
  {
    id: 6,
    title: "Loot",
    year: 2012,
    genre: ["Action", "Comedy"],
    runtime: "2h 05m",
    director: "Nischal Basnet",
    cast: ["Saugat Malla", "Nischal Basnet", "Dayahang Rai"],
    synopsis: "A group of unlikely criminals attempt to pull off a heist in Kathmandu — Nepal's first action comedy that changed Kollywood forever.",
    score: 8.2,
    totalRatings: 1500,
    emoji: "💰",
    color: "#1a1010",
    whereToWatch: [
      { name: "YouTube", type: "free · with ads", free: true },
    ],
    ratings: { masterpiece: 14, dhamaka: 48, thaikaicha: 28, timepass: 8, naramro: 2, bakwaas: 0 },
    boxOffice: "Rs 4.2 cr",
    trending: false,
  },
];

export const discussions = [
  {
    id: 1,
    type: "battle",
    question: "Which is the better Bipin Karki performance — Kabaddi or Unko Sweater?",
    user: "Roshan K.",
    userInitials: "RK",
    userColor: "#2a1510",
    userTextColor: "#FF5C35",
    location: "Helsinki",
    movieTags: ["Bipin Karki"],
    time: "3h ago",
    sideA: { label: "Kabaddi", votes: 344, pct: 62, color: "#FF5C35", btnBg: "#2a1510", btnBorder: "#3a2010" },
    sideB: { label: "Unko Sweater", votes: 211, pct: 38, color: "#7777dd", btnBg: "#10102a", btnBorder: "#1a1a3a" },
    totalVotes: 555,
    replies: 89,
    spicy: false,
  },
  {
    id: 2,
    type: "hottake",
    question: "Pashupati Prasad is overrated and Loot is actually the better Nepali comedy. Fight me.",
    user: "Binod P.",
    userInitials: "BP",
    userColor: "#1a1025",
    userTextColor: "#9F77DD",
    location: "Australia",
    movieTags: ["Pashupati Prasad", "Loot"],
    time: "6h ago",
    agreePct: 28,
    disagreeCount: 183,
    agreeCount: 468,
    totalVotes: 651,
    replies: 134,
    spicy: true,
  },
  {
    id: 3,
    type: "scene",
    question: "The final sarangi scene in Purna Bahadur Ko Sarangi — when did you realize you were going to cry?",
    user: "Sunita M.",
    userInitials: "SM",
    userColor: "#101a10",
    userTextColor: "#4a9a4a",
    location: "Kathmandu",
    movieTags: ["Purna Bahadur Ko Sarangi"],
    time: "1d ago",
    sceneTag: "scene · act 3 · no major spoilers",
    quote: "The moment he starts playing and his son turns around... I lost it completely. The music does something to you.",
    felt: 412,
    replies: 97,
  },
  {
    id: 4,
    type: "predict",
    question: "Before you watched it — what rating did you predict for Unko Sweater?",
    user: "Anil K.",
    userInitials: "AK",
    userColor: "#1a1500",
    userTextColor: "#9a8a3a",
    location: "Japan",
    movieTags: ["Unko Sweater"],
    time: "2d ago",
    options: [
      { label: "Bakwaas", pct: 2, count: 14, winner: false },
      { label: "Timepass", pct: 8, count: 54, winner: false },
      { label: "Thikai Cha", pct: 31, count: 208, winner: false },
      { label: "Dhamaka", pct: 59, count: 396, winner: true },
    ],
    actualRating: "Dhamaka",
    accuracy: 59,
    totalPredictions: 672,
    replies: 44,
  },
  {
    id: 5,
    type: "spoiler",
    question: "Did the ending of Kabaddi 2 make sense or did it feel forced? [full spoilers inside]",
    user: "Pratik K.",
    userInitials: "PK",
    userColor: "#1a1010",
    userTextColor: "#9a4a4a",
    location: "UK",
    movieTags: ["Kabaddi 2"],
    time: "3d ago",
    replies: 61,
  },
];

export const weeklyBattle = {
  question: "Best Nepali film of the last 10 years",
  sideA: { label: "Pashupati Prasad", pct: 44 },
  sideB: { label: "Purna Bahadur Ko Sarangi", pct: 56 },
  totalVotes: 2841,
  closesIn: "1d 14h",
};

export const trendingDebates = [
  { rank: 1, text: "Is Dayahang Rai Nepal's greatest ever actor?", replies: 841 },
  { rank: 2, text: "Chhakka Panja series — which is the best one?", replies: 612 },
  { rank: 3, text: "Should Nepali films have English subtitles by default?", replies: 504 },
  { rank: 4, text: "Most underrated Nepali film nobody talks about?", replies: 388 },
  { rank: 5, text: "Nischal Basnet vs Bipin Karki — who defines modern Kollywood?", replies: 291 },
];

export const ratingLabels = [
  { key: "masterpiece", icon: "🏆", label: "Masterpiece", nepali: "all time" },
  { key: "dhamaka", icon: "🔥", label: "Dhamaka", nepali: "must watch" },
  { key: "thaikaicha", icon: "👍", label: "Thikai Cha", nepali: "pretty good" },
  { key: "timepass", icon: "😐", label: "Timepass", nepali: "just ok" },
  { key: "naramro", icon: "👎", label: "Naramro", nepali: "not great" },
  { key: "bakwaas", icon: "💀", label: "Bakwaas", nepali: "skip it" },
];
